module.exports = __webpack_public_path__ + "img/GRC.729c204a.svg";